// eslint-disable-next-line no-unused-vars
import { EyeOutlined } from "@ant-design/icons";
// eslint-disable-next-line no-unused-vars
import { Image } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

const ImageGallery = ({ data }) => {
  const [selected, setSelected] = useState(null);
  const [remaining, setRemaining] = useState(null);

  useEffect(() => {
    if (data) {
      setRemaining(data);
      setSelected(data[0]);
    }
  }, [data]);

  const handleSelectImage = (image) => {
    setSelected(image);
  };

  return (
    <>
      <Image.PreviewGroup
        preview={{
          onChange: (current, prev) =>
            console.log(`current index: ${current}, prev index: ${prev}`),
        }}
      >
        {remaining !== null &&
          remaining.map((i, k) => (
            <Image
              key={`${i.toString()}-${k}`}
              src={i}
              style={{ display: i === selected ? "block" : "none" }}
              preview={{
                mask: (
                  <div>
                    <EyeOutlined /> Ampliar
                  </div>
                ),
              }}
            />
          ))}
      </Image.PreviewGroup>
      <div className="mt-2 space-x-2 space-y-2">
        {remaining !== null &&
          remaining.map((i, k) => (
            <Image
              key={`${i.toString()}-${k}`}
              src={i}
              style={{ border: i === selected ? "1px solid black" : "none" }}
              className="h-10"
              width="40px"
              onClick={() => handleSelectImage(i)}
              preview={false}
            />
          ))}
      </div>
    </>
  );
};

ImageGallery.propTypes = {
  data: PropTypes.object
}

export default ImageGallery;
